package org.hs_soft.runmynesto.domain.usecase.options.cash_register_config

import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices.create_new_shop.CreateNewShopModel
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.pms_config.apaleo_properties.ApaleoPropertieModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.ApaleoPropertiesRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.CreateNewShopRepository


class ApaleoPropertiesUseCase(
    private val repository: ApaleoPropertiesRepository
) {
    suspend operator fun invoke(): ApaleoPropertieModel {
        return repository.getApaleoProperties()
    }
}